import { PERFORMANCE_METRIC_NAMES } from "./types";
import { startPerformanceTimer } from "./timers";

let bootstrapTimer: ReturnType<typeof startPerformanceTimer> | null = null;

/** Called from {@link mountShell} before React root creation. */
export function markShellBootstrapStart(): void {
  bootstrapTimer?.cancel();
  bootstrapTimer = startPerformanceTimer(PERFORMANCE_METRIC_NAMES.shellBootstrap, {});
}

/** Called once from {@link ShellRoot} after the provider tree mounts. */
export function markShellBootstrapComplete(): void {
  bootstrapTimer?.complete("success");
  bootstrapTimer = null;
}
